module.exports = __webpack_public_path__ + "img/dgroup_25.0a92ef56.jpg";